import { render, staticRenderFns } from "./NavTopMenu.vue?vue&type=template&id=b52fe3b2&"
import script from "./NavTopMenu.vue?vue&type=script&lang=js&"
export * from "./NavTopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports